import cloneDeep from 'lodash/cloneDeep'
import { MeasResultCd } from '@/enum'
export default {
  methods: {
    /**
     * Get ["st", "nd", "rd", "th"] Suffixes
     */
    getNumberSuffix(n) {
      const str = ['st', 'nd', 'rd'][((((n + 90) % 100) - 10) % 10) - 1] || 'th'
      return `${n}${str}`
    },
    isEmpty(str) {
      return str === '' || str === null
    },
    isAllEmpty(...args) {
      let result = true
      if (args.some((arg) => arg != '' && arg != null)) {
        result = false
      }
      return result
    },
    /**
     * Convert asymmetrical table to CSV (非対称テーブルを CSV に変換する)
     * Doesnot include headers (ヘッダーは含まれていない)
     * @param {Array} items => main table array
     * @param {Array} itemsHeaderArray => column's header in array
     * @param {Array} rowInitialsArray => keys of row's first two columns in array
     */
    convertToCSV(items, itemsHeaderArray, rowInitialsArray) {
      const array = cloneDeep(items)
      return array
        .map((data) => {
          let val =
            itemsHeaderArray?.map((value) => {
              // eslint-disable-next-line no-prototype-builtins
              if (data.hasOwnProperty(value)) {
                return data[value]
              }
            }) ?? []
          let rowInitialArr =
            Object.entries(data).filter(([key, value]) => {
              if (rowInitialsArray?.includes(key)) {
                return [key, value]
              }
            }) ?? []
          let obj = Object.fromEntries(rowInitialArr)
          let rowInitials = Object.values(obj)
          const returnVal = [...rowInitials, ...val]
          return Object.values(returnVal).toString()
        })
        .join('\n')
    },
    getInspResultName(key, value, isOutCl) {
      // langのenumからメッセージ取得
      let lang = ''
      if (value) {
        lang = this.$t(key + value)
      }
      if (value == MeasResultCd.OK && isOutCl) {
        return lang + this.$t('ELE0540')
      } else return lang
    },
      normalizeUrl(url) {
         //urlを正規化しhrefに返します
        let href =''
        try {
          const u = new URL(url) // 構文をチェック＆正規化
          if (['http:', 'https:'].includes(u.protocol)) {
            href = u.toString()
          }
        } catch {
          href = '' // 無効なURL
        }
      return href
    },
      toBase64(str) {
        // UTF-8対応 Base64 エンコード
        const utf8 = new TextEncoder().encode(str)
        return  btoa(String.fromCharCode(...utf8))
    },
  },
}
